module.exports = __webpack_public_path__ + "img/column-stack.73721fe2.svg";